var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('schedule-tag-select',{attrs:{"tags":_vm.tags,"multiple":""},on:{"submit":_vm.submit},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mx-1",attrs:{"icon":"","tile":"","loading":_vm.updating,"x-small":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-tag-plus-outline")])],1)]}}]),model:{value:(_vm.ids),callback:function ($$v) {_vm.ids=$$v},expression:"ids"}})}
var staticRenderFns = []

export { render, staticRenderFns }